import Quantity from '../Quantity.js'

/**
 * A summary of the list count that might contain page info
 *
 * @param {Object} props
 * @param {Number} [props.limit]
 * @param {Number} [props.offset]
 * @param {Number} props.count
 * @param {String} props.thing
 * @returns {React.ReactNode}
 */
export default function ListItemsCount({limit, offset, count, thing}) {
  let fromCount
  let toCount

  if (offset !== undefined && limit !== undefined) {
    fromCount = offset + 1
    toCount = Math.min(offset + limit, count)
  }

  return (
    <div className="inline-block list-items-count fs-n0 lh-sm v-align-middle">
      {fromCount === undefined ||
      toCount === undefined ||
      count === 0 ? null : (
        <span>
          <strong>
            <span>{fromCount}</span>-<span>{toCount}</span>
          </strong>
          <span> of </span>
        </span>
      )}
      <strong>
        <span>
          <Quantity value={count} />
        </span>{' '}
        <span>{thing}</span>
      </strong>
    </div>
  )
}
